import RouterSection from '@/layout/components/RouterSection'

export default {
  path: '/mobile',
  name: 'mobileHome',
  component: RouterSection,
  redirect: { name: 'mobileLogin' },
  children: [
    {
      path: 'login',
      name: 'mobileLogin',
      component: () => import('@/views/mobile/nMobileLogin.vue'),
      meta: {
        asideView: false,
        tagView: false,
        headerView: false,
        footerView: true
      }
    },
    {
      path: 'centeras',
      name: 'CenterAS',
      component: () => import('@/views/mobile/CenterAS.vue'),
      meta: {
        asideView: false,
        tagView: false,
        headerView: true
      }
    },
    {
      path: 'personalmonitoring',
      name: 'PersonalMonitoring',
      component: () => import('@/views/mobile/PersonalMonitoring.vue'),
      meta: {
        asideView: false,
        tagView: false,
        headerView: true
      }
    },
    {
      path: 'locationMap',
      name: 'mobileLocationMap',
      component: () => import('@/views/mobile/site/LocationMap.vue')
    },
    {
      path: 'constructor',
      name: 'Constructor',
      component: () => import('@/views/mobile/Constructor.vue'),
      meta: {
        asideView: false,
        tagView: false,
        headerView: true
      }
    },
    {
      path: 'siteWork',
      name: 'mobileSiteWork',
      component: () => import('@/views/mobile/site/SiteWork.vue')
    },
    {
      path: 'ess/siteWork',
      name: 'essSiteWork',
      props: true,
      component: () => import('@/views/mobile/ess/SiteWork.vue'),
      meta: { asideView: false, tagView: false }
    },
    {
      path: 'ess/siteWeather',
      name: 'SiteWeatherTop',
      props: true,
      component: () => import('@/components/mobile/SiteWeatherTop.vue'),
      meta: { asideView: false, tagView: false }
    },
    {
      path: 'cctvList',
      name: 'cctvList',
      // props: true,
      component: () => import('@/views/mobile/site/cctvList.vue')
    },
    {
      path: 'siteRegisterPCS',
      name: 'mobileSiteRegisterPCS',
      component: () => import('@/views/mobile/site/SiteRegisterPCS.vue')
    }
  ]
}
